import React from 'react';

// Components
import SubscriptionStatus from './SubscriptionStatus';

const Header = ({ first_name, last_name, username, active_payment, free_subscription }) => (
  <div className="admin-profile-card-header">
    <h5>
      <span>
        <span>Username: </span> {`${username}`}
      </span>
      <span>
        <span>Status: </span>
        <SubscriptionStatus active_payment={active_payment} free_subscription={free_subscription} />
      </span>
    </h5>
    <h2>{`${first_name} ${last_name}`}</h2>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/ProfileHeader.js